// extracted by mini-css-extract-plugin
export default {"email":"EmailConfirmationModal_email__sNriF"};